import { Icon, Button } from "@whitespace/components";
import { Loading } from "@whitespace/gatsby-theme-smorgasbord/src/components";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import useEdp from "../hooks/useEdp";
import {
  base64ToArrayBuffer,
  getBlobFileURL,
  downloadBlobFile,
} from "../utils/byteToPdf.js";

import * as defaultStyles from "./WastePickupSearchResultsItem.module.css";

WastePickupSearchResultsItem.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  buildingId: PropTypes.string.isRequired,
  buildingAddress: PropTypes.string.isRequired,
};

export default function WastePickupSearchResultsItem({
  styles = defaultStyles,
  className,
  buildingId,
  buildingAddress,
  ...restProps
}) {
  const { t } = useTranslation();
  const { loading } = useEdp();

  return (
    <li className={clsx(styles.component, className)} {...restProps}>
      <p>
        {buildingAddress} ({buildingId})
      </p>
      <Button
        className={clsx(styles.downloadButton)}
        disabled={loading}
        type="external"
        href={`/api/edp/buildings/${buildingId}/waste-pickup.pdf`}
        download={`waste-pickup-${buildingId}.pdf`}
      >
        {loading ? (
          <Loading className={styles.loading} />
        ) : (
          <>
            <span className={clsx(styles.downloadButtonText)}>
              {t("downloadPDF")}
            </span>
            <Icon name={"download"} />
          </>
        )}
      </Button>
    </li>
  );
}
